export class BerthCallInfo {
    constructor(berthCallId: number, name: string) {
        this.berthCallId = berthCallId;
        this.name = name;
    }
    berthCallId: number;
    name: string;
}
